import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {CompetitionsSliderWidgetState} from "./models/competitions-slider-widget.state";
import {CompetitionsSliderWidgetConfig} from "./competitions-slider-widget.config";

export class CompetitionsSliderWidgetStore extends BaseMobxStore {
  static injectables = [CompetitionsSliderWidgetConfig, CompetitionsSliderWidgetState];
}

